import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';
import LinkBox from '../components/LinkBox';

export type PIEnergyEfficiencyProps = {};

const PIEnergyEfficiency: React.FC<PIEnergyEfficiencyProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/office-scene.png'}
        heading={
          intl.formatMessage({
            id: 'public_info_4'
          })
        }
       />
      <div className="content">
        <div className="w-full flex flex-row flex-wrap">
          <div className="w-1/2 p-2">
          <LinkBox target="_blank" href="/pdf/energy/MCB-SMR-032 Uso de la contrasena y marca de conformidad.docx" label={
              intl.formatMessage({
                id: 'pw-usage'
              })
            } />
          </div>
          <div className="w-1/2 p-2">
            <LinkBox target="_blank" href="/pdf/energy/MCB-CCP-002 Contrato general de prestacion de servicios de certificacion.docx" label={
              intl.formatMessage({
                id: 'service-contract'
              })
            } />
          </div>
          <div className="w-1/2 p-2">
            <LinkBox target="_blank" href="/pdf/energy/MCB-DOE-083 Solicitud de Servicios Eficiencia.docx" label={
              intl.formatMessage({
                id: 'req-eff'
              })
            } />
          </div>
          <div className="w-1/2 p-2">
            <LinkBox target="_blank" href="/pdf/energy/MCB-DOE-082 Requisitos de Certificacion Eficiencia.pdf" label={
              intl.formatMessage({
                id: 'cert-eff-req'
              })
            } />
          </div>
          <div className="w-1/2 p-2">
            <LinkBox target="_blank" href="/pdf/energy/MCB-DOE-109 Lista de precios NOM Eficiencia energetica.pdf" label={
              intl.formatMessage({
                id: 'price-list'
              })
            } />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PIEnergyEfficiency;